<script setup>
  const props = defineProps({
    event: {
      type: Object,
      required: true
    },
    hostname: {
      type: String,
      required: true
    },
    eventDetails: {
      type: String,
      required: true
    }
  });
  const formatDate = ((date) => {
    const options = {weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC'};
    return new Date(date).toLocaleDateString('en-US', options);
  });
  const getTarget = (link => {
    if (link.includes(props.hostname) || !link.includes('http')) {
      return '_top';
    } else {
      return '_blank';
    }
  });
</script>

<template>
  <article class="horzlayout event">
    <div class="horzimage">
      <a class="card-image-link" :href="event.link"></a>
      <div class="card-image-top">
        <img class="img-fluid" v-bind:src="event.image" v-bind:alt="event.eventName"/>
      </div>
    </div>
    <div class="horzcontent event">
      <div class="card-body">
        <h2 class="card-title"><a class="card-heading-link" :href="event.link">
          {{ event.eventName }}</a>
        </h2>
        <div class="card-text">
          <time>{{ formatDate(event.startDate) }}</time>
          <time v-if="event.endDate && event.endDate !== event.startDate"> –
            {{ formatDate(event.endDate) }}
          </time>
          <div v-html="event.location"></div>
          <div v-html="event.eventDescription"></div>
        </div>
        <div class="card-links">
          <a v-if="event.link" class="card-link" v-bind:target="getTarget(event.link)"
             :href="event.link">
            <span class="sr-only">{{ event.eventName }} </span>{{ eventDetails }}
            <i v-if="event.link.includes(hostname) || !event.link.includes('http')" class="fass fa-chevron-right"
               aria-hidden="true"></i>
            <i v-else class="fass fa-up-right-from-square" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
  </article>
</template>

<style scoped>

</style>